<template lang="html">
<div>
  <toolbar title="Refer a Friend!">
  </toolbar>
  <v-layout column>

    <v-card class="py-3 pl-5">

        <h1 class="display-2 pt-4">
          Refer a Friend!
        </h1>

        <p  class="headline py-2">
          Invite a friend you use {{ $t('site-title.brief') }}.
          After they book their first load, you will both receive $50 account credit.
        </p>

        <h6 class="subheading font-weight-bold">Your referral link:</h6>

        <v-layout>
          <v-tooltip top>
            <p slot="activator" class="refer-link" @click="copyLink">
              {{referLink}}
            </p>
            <span>Click to copy</span>
          </v-tooltip>
        </v-layout>

        <h6 class="mt-5 mb-2 subheading font-weight-bold">
          Or enter your friends email and we'll take care of the rest
        </h6>
      <form data-vv-scope="invite" v-on:submit.prevent>
        <v-layout wrap >
          <v-flex xs7>
          <v-text-field label="Email address"
              prepend-icon="mail"
              v-model="email"
              :error-messages="errors.first('email', 'invite')"
              data-vv-as="Email address"
              data-vv-name="email"
              data-vv-scope="invite"
              v-validate="'required|email'" />
          <v-text-field label="Message (optional)"
              prepend-icon="chat"
              v-model="message"
              data-vv-as="Message (optional)"
              data-vv-name="message"
              data-vv-scope="invite" />
            <v-btn color="primary"
                   :loading="loadingBtn"
                   :disabled="errors.any()"
                   @click="sendEmail">Send</v-btn>
          </v-flex>
        </v-layout>
      </form>
    </v-card>
  </v-layout>
  </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapState } from 'vuex';
import API from '@/api';
import Toolbar from '@/components/Toolbar';


const { mapFields } = createHelpers({
  getterType: 'profiles/getField',
  mutationType: 'profiles/updateField',
});

export default {
  name: 'Profile',
  components: {
    Toolbar,
  },
  computed: {
    ...mapState('profiles', {
      userInfo: 'userInfo',
      userProfile: 'userProfile',
    }),
    ...mapFields([
      'userInfo.contactEmail',
    ]),
    referLink() {
      return `${document.location.origin}/onboard?referrer=${this.userInfo.referralCode}`;
    },
  },
  data: () => ({
    medicalExpiresDateMenu: false,
    cdlExpiresDateMenu: false,
    showDriverProfile: false,
    email: null,
    message: null,
    loadingBtn: false
  }),

  created() {
    window.__insp.push(['tagSession', 'open_refer']);
    this.$store.dispatch('applications/addLoading', [
      this.$store.dispatch('profiles/getUser'),
    ]);
  },

  methods: {
    copyLink() {
      this.$copyText(this.referLink).then(() => {
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Link copied to clipboard',
        });
      });
    },
    async sendEmail(scope) {
      window.__insp.push(['tagSession', 'send_refer']);
      this.loadingBtn = true;
      const isValid = await this.$validator.validateAll(scope);
      if (isValid) {
        API.referral.sendReferral({
          emailAddress: this.email,
          message: this.message,
        }).then(() => {
          this.$validator.reset();
          this.email = null;
          this.message = null;
          this.$store.dispatch('applications/setSuccessNotification', {
            message: `Thanks for sharing ${this.$t('site-title.brief')}! Referral Sent!`,
          });
          this.loadingBtn = false;
        }).catch(() => {
          this.$store.dispatch('applications/setSuccessNotification', {
            message: 'Something went wrong. Please try again later.',
          });
        });
      }
    },
  },
};
</script>

<style lang="css" scoped>
p.refer-link{
  background-color: #f8f8f8;
  padding: 8px;
  margin-top: 8px;
  display: inline-block;
  border-radius: 4px;
  border:1px solid #e3e3e3;
}
</style>



// WEBPACK FOOTER //
// src/pages/User/Refer.vue